// Shared Framer Motion variants for scroll-triggered reveals.
// Framer Motion's MotionConfig(reducedMotion="user") in App.js automatically
// simplifies/removes transform-based motion for users with the OS
// "reduce motion" preference set, so these stay safe to use everywhere.

export const fadeInUp = {
    hidden: { opacity: 0, y: 24 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

export const staggerContainer = {
    hidden: {},
    visible: {
        transition: { staggerChildren: 0.12 },
    },
};

export const viewportOnce = { once: true, amount: 0.2 };
